import React from "react";

class Spacer extends React.Component {
  render() {
    return (
      <section className="spacer theme-bg-confetti"></section>
    );
  }
}

export default Spacer;



// WEBPACK FOOTER //
// ./src/components/spacer.js